import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ImpersonateUserParams,
  UpdateProfileParams,
} from 'lib/api/requests/user/user.requests.types';
import iotApi from '../../api/iotApi.client';
import { UserQueryKey } from './user.hooks.keys';

export function useImpersonateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: ImpersonateUserParams) => {
      const { userId } = params;
      const res = await iotApi.user.impersonateUser({
        userId,
      });

      return res.token;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([UserQueryKey.FETCH_ME]);
    },
  });
}

export function useUpdateProfile() {
  return useMutation({
    mutationKey: [UserQueryKey.UPDATE_PROFILE],
    mutationFn: async (params: UpdateProfileParams) => {
      const res = await iotApi.user.updateProfile(params);

      return res;
    },
  });
}
